import { Loadable } from '@/commons/lodeable';
import { Card, CardContent, CardHeader, Divider, Stack } from '@mui/material';
import { lazy } from 'react';

type Props = {
  title?: string;
  isCurrency?: boolean;
  data: {
    label: string;
    value: number;
  }[];
};

export const CardDetailPie = ({ data = [], title, isCurrency }: Props) => {
  if (!data.length) return null;
  const Pie = Loadable(lazy(() => import('@/commons/chart/pie')));

  return (
    <Card
      sx={{
        width: '100%',
        height: '100%',
      }}
    >
      <CardHeader title={title ?? 'Cash Journal'} />
      <Divider />
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
          
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
      >
        <Stack>
          <Pie
            chart={{
              options: {
                chart: {},
              },

              series: data,
            }}
            isCurrency={isCurrency}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};
